import React from 'react';
import { Outlet, Routes, Route, Navigate } from 'react-router-dom';
import { StatsPage, RolesPage, PlayersPage } from './index';
import DetailsPage from './DetailsPage';
import RosterPage from './RosterPage';
import KPIsPage from './KPIsPage';
import PeriodsPage from './PeriodsPage';
import GameHeader from './GameHeader';
import GameTeamsPage from './GameTeamsPage';
import ProtectedRoute from '../../routes/ProtectedRoute';
import { PermissionLevel } from '../../config/permissions';
import { sessionManager } from '../../config/sessionManager';

const GameHome: React.FC = () => {
  return (
    <div className="w-full">
      <GameHeader />
      <main className="w-full rounded-b flex-1 flex flex-col items-center relative z-60">
        <Outlet />
      </main>
    </div>
  );
};

// Component to determine default redirect based on permissions
const GameDefaultRedirect: React.FC = () => {
  // Check if user can access stats (first priority)
  const canAccessStats = sessionManager.hasPermission('games.gameMenu.stats', PermissionLevel.VIEW);

  // Redirect to first available tab
  if (canAccessStats) return <Navigate to="stats" replace />;
  // Roles is always accessible
  return <Navigate to="roles" replace />;
};

const GameHomeRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<GameHome />}>
        <Route index element={<GameDefaultRedirect />} />
        <Route
          path="stats"
          element={
            <ProtectedRoute requirePermission="games.gameMenu.stats">
              <StatsPage />
            </ProtectedRoute>
          }
        />
        <Route path="roles" element={<RolesPage />} />
        <Route path="teams" element={<GameTeamsPage />} />
        <Route path="players" element={<PlayersPage />} />
        {/* Details section routes */}
        <Route
          path="details"
          element={
            <ProtectedRoute requirePermission="games.gameMenu.details">
              <DetailsPage />
            </ProtectedRoute>
          }
        />
        <Route path="roster" element={<RosterPage />} />
        <Route
          path="kpis"
          element={
            <ProtectedRoute requirePermission="games.gameMenu.kpis">
              <KPIsPage />
            </ProtectedRoute>
          }
        />
        <Route path="periods" element={<PeriodsPage />} />
      </Route>
    </Routes>
  );
};

export default GameHomeRoutes;
